import React, { useLayoutEffect, useState } from "react";
import { urlFor } from "../client";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import { useGlobalContext } from "../Context";
import Button from "../Components/Utils/Button";
import Pagination from "../Components/Reuseable/Pagination";
import { useEffect } from "react";
import BlogSection from "../Components/Reuseable/BlogSection";
import { color } from "../Components/Utils/Color";

export default function Blog() {
  const { setNav, blog } = useGlobalContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(5);
  const [scroll, setScroll] = useState(false);

  const scrollMeasure = () => {
    if (window.innerWidth > 745) {
      setScroll(true);
    } else {
      setScroll(false);
    }
    // console.log();
  };

  useEffect(() => {
    window.addEventListener("scroll", scrollMeasure);

    return () => {
      window.removeEventListener("scroll", scrollMeasure);
    };
  }, []);

  useLayoutEffect(() => {
    setNav(false);
    document.title = "Beyond Limits Football Academy - General News";
  }, [setNav]);

  // console.log(blog);

  const lastPostIndex = currentPage * postPerPage;
  const firstPostIndex = lastPostIndex - postPerPage;
  const post = blog?.slice(firstPostIndex, lastPostIndex);

  const increaseBlog = () => {
    setPostPerPage((prev) => {
      return prev + 5;
    });
  };

  if (blog.length === 0) {
    return (
      <section style={{ height: "50rem" }}>
        <div className="container">
          <p
            style={{
              fontSize: "5rem",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            We don't have any news at the moment
          </p>
          <p
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              textAlign: "center",
              marginTop: "1rem",
            }}
          >
            Check back later.
          </p>
        </div>
      </section>
    );
  }
  // console.log(post);

  return (
    <>
      <section className="Blog mb-[50px]">
        <div className="container">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <p className="Players__title">general news</p>
          </div>
          <div className="mx-auto w-full flex flex-col items-center !mt-[10px] mb-[30px] sm:grid  gap-x-8 gap-y-16 border-t border-gray-200 pt-[1rem] sm:mt-16  lg:mx-0 sm:grid-cols-2 lg:grid-cols-3">
            {post.map((blog) => {
              return <BlogSection post={blog} key={blog._id} />;
            })}
          </div>
          {postPerPage < blog.length && (
            <div
              onClick={increaseBlog}
              className={`flex items-center justify-center cursor-pointer mx-auto w-[200px] px-[30px] py-[10px] !border-[#007cba] border-[2px]`}
            >
              <span
                className={`text-[${color.primary}] text-[20px] uppercase font-semibold`}
              >
                load more
              </span>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

